import styled from "styled-components";

const ModalBody = styled.div`
	width: 630px;
`;

export { ModalBody };
